import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { TripService } from 'src/app/trip-calculator/services/trip.service';

@Component({
  selector: 'app-main-transport-checkbox',
  imports: [CheckboxModule, FormsModule],
  templateUrl: './main-transport-checkbox.component.html',
})
export class MainTransportCheckboxComponent {
  tripService = inject(TripService);
  @Input() index!: number;

  set isMainTransport(value: boolean) {
    const transport = this.tripService.trip()?.transports[this.index];
    if (!transport) return;
    transport.isMainTransport = value;
    this.tripService.updateTransport(transport, this.index)?.subscribe();
  }
  get isMainTransport() {
    return (
      this.tripService.trip()?.transports[this.index].isMainTransport ?? false
    );
  }
}
